<template>
	<div class="k-site">
		<FAIcon icon="angle-up" size="2x" ref="scrollTopButton" id="hero-scroll-top" v-scroll-to="'#header'" />
		<header id="header" v-waypoint="{ active: true, callback: scrolling, options: intersectionOptions }">
			<Hero :hero-data="heroData" />
		</header>
		<main>
			<div id="main" class="main">
				<section id="duty" class="duty">
					<Duty :duty-data="dutyData" />
				</section>
				<section id="showcase" class="showcase">
					<Showcase :showcase-data="showcaseData" />
				</section>
				<section id="team" class="team">
					<Team :team-data="teamData" />
				</section>
				<!-- <section id="gallery" class="gallery">
					<Gallery :gallery-data="galleryData" />
				</section> -->
				<section id="contact" class="contact">
					<Contact :contact-data="contactData" />
				</section>
			</div>
		</main>
		<footer>
			<section id="footer" class="footer">
				<Footer />
			</section>
		</footer>
	</div>
</template>

<script>
import Hero from '@/components/Hero.vue'
import Duty from '@/components/Duty.vue'
import Showcase from '@/components/Showcase.vue'
import Team from '@/components/Team.vue'
// import Gallery from '@/components/Gallery.vue'
import Contact from '@/components/Contact.vue'
import Footer from '@/components/Footer.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

library.add(fas, fab)

export default {
	name: 'Home',

	components: {
		Hero,
		Duty,
		Showcase,
		Team,
		// Gallery,
		Contact,
		Footer
	},

	data() {
		return {
			heroData: {},
			dutyData: {},
			showcaseData: {},
			teamData: {},
			galleryData: {},
			contactData: {},
			intersectionOptions: {
				root: null,
				rootMargin: '0px',
				threshold: [0.15]
			}
		}
	},

	created() {
		this.fetchHeroData()
		this.fetchDutyData()
		this.fetchShowcaseData()
		this.fetchTeamData()
		this.fetchGalleryData()
		this.fetchContactData()
	},

	methods: {
		fetchHeroData() {
			this.$store.dispatch('hero/fetchData')
			this.heroData = this.$store.getters['hero/data']
		},
		fetchDutyData() {
			this.$store.dispatch('duty/fetchData')
			this.dutyData = this.$store.getters['duty/data']
		},
		fetchShowcaseData() {
			this.$store.dispatch('showcase/fetchData')
			this.showcaseData = this.$store.getters['showcase/data']
		},
		fetchTeamData() {
			this.$store.dispatch('team/fetchData')
			this.teamData = this.$store.getters['team/data']
		},
		fetchGalleryData() {
			this.$store.dispatch('gallery/fetchData')
			this.galleryData = this.$store.getters['gallery/data']
		},
		fetchContactData() {
			this.$store.dispatch('contact/fetchData')
			this.contactData = this.$store.getters['contact/data']
		},

		scrolling({ going, direction }) {
			let goingIn = going === this.$waypointMap.GOING_IN
			let goingOut = going === this.$waypointMap.GOING_OUT
			let directionTop = goingIn && direction === this.$waypointMap.DIRECTION_TOP
			let directionBottom = goingIn && direction === this.$waypointMap.DIRECTION_BOTTOM
			const heroVideo = this.$store.getters['hero/video']

			if (goingIn) {
				this.$refs.scrollTopButton.style.display = 'none'
			}

			if (goingOut) {
				this.$refs.scrollTopButton.style.display = 'block'
			}

			if (directionTop && !heroVideo.paused) {
				heroVideo.pause()
				this.$refs.scrollTopButton.style.display = 'block'
			}

			if (directionBottom && heroVideo.paused) {
				heroVideo.play()
				this.$refs.scrollTopButton.style.display = 'none'
			}
		}
	}
}
</script>
